import { AutoComplete, DatePicker, Input, Select } from "antd";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { Products, get_addresses, get_products } from "../../actions/orders";
import {
  DownloadDocClaimList,
  SubmitClaims,
  doc_claims_list,
  download_doc_claim_list,
  get_claim,
  submit_claims,
} from "../../actions/shipmentNPayment";
import Close from "../../assets/cancel.svg";
import AddTable from "../../common/AddTable";
import PopupComponent from "../../common/Popup";
import { apis } from "../../config/apis";
import endpoint from "../../config/endpoint";
import { getAddress } from "../../config/helper";
import { NavWrap } from "../ShopForTyres";
import _ from "lodash";
import "./claims.css";

const claimValidation = yup.object().shape({
  // Street: yup.string().required("Street is required."),
  Ort01: yup.string().required("City is required"),
  Bstdk: yup.string(),
  Pstlz: yup
    .string()
    .required("Pincode is required.")
    .matches("[0-9]", "Please enter a valid pincode."),
  Items: yup.array().of(
    yup.object({
      // Msize: yup.string().required("Size is required."),
      // Pattern: yup.string().required("Pattern is required."),
      Matnr: yup.string().required("Tyre is required"),
      Augru: yup.string(),
      Kwmeng: yup.string().required("Quantity is required."),
      Werks: yup.string(),
      MileageTirekm: yup.string(),
      DrivingCondition: yup.string(),
      ZzclaimReason: yup.string().required("Claim reason is required."),
      ThreadDepth: yup.string().required("Thread Depth is required."),
      TyreRotFreq: yup.string(),
      InpressureTyre: yup.string(),
      LoadPerc: yup.string(),
      Dotno: yup.string().required("Dot number is required."),
    })
  ),
});

const RetailerOwnerForm = ({ formik, params }) => {
  const addresses = useSelector(
    (state) => state?.orders?.addresses?.data || []
  );
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");

  return (
    <div className="form addr">
      {/* <div>
        <span>Name</span>
        <input name="Name1" onChange={formik.handleChange} value={formik.values.Name1} disabled={params?.id} />
      </div> */}
      <div>
        <span>Address *</span>
        {!params?.id ? (
          <Select
            style={{
              maxWidth: "16rem",
            }}
            options={
                addresses?.length
                  ? _.uniqBy(
                      permissions?.claims?.full_access || permissions?.claims?.view
                        ? // ✅ Delegate user → only show addresses matching ANY shipment_code in the array
                          addresses.filter((ele) =>
                            (permissions?.claims?.shipment_code || []).includes(ele.kunn2)
                          )
                        : // Non-delegate user → show all
                          addresses,
                      "sap_ref"
                    ).map((ele) => ({
                      ...ele,
                      label: getAddress(ele),
                      value: ele.address1,
                    }))
                  : []
              }
            onChange={(val, obj) => {
              formik.setValues({
                ...formik.values,
                Street: val,
                Ort01: obj.city,
                Pstlz: obj.zip,
                Shiptonum: obj.kunn2,
                address1: obj.address1
              });
            }}
          />
        ) : (
          <textarea
            name="Street"
            onChange={formik.handleChange}
            value={`${formik.values?.Name1}${formik.values?.Name1 && ", "}${
              formik.values?.Street
            }`}
            disabled={params?.id}
          />
        )}
      </div>
      {formik.touched?.Street && formik.errors?.Street && (
        <div className="error-msg">{formik.errors?.Street}</div>
      )}
      <div>
        <span>City *</span>
        <input
          name="Ort01"
          onChange={formik.handleChange}
          value={formik.values.Ort01}
          disabled={params?.id || formik.values.Ort01}
        />
      </div>
      {formik.touched?.Ort01 && formik.errors?.Ort01 && (
        <div className="error-msg">{formik.errors?.Ort01}</div>
      )}
      {/* <div>
        <span>State</span>
        <input name="Vtweg" onChange={formik.handleChange} value={formik.values.Vtweg} disabled={params?.id} />
      </div> */}
      <div>
        <span>Postal code *</span>
        <input
          name="Pstlz"
          onChange={formik.handleChange}
          value={formik.values.Pstlz}
          disabled={params?.id || formik.values.Pstlz}
        />
      </div>
      {formik.touched?.Pstlz && formik.errors?.Pstlz && (
        <div className="error-msg">{formik.errors?.Pstlz}</div>
      )}
    </div>
  );
};

const VehicleForm = ({ formik, params }) => {
  return (
    <div className="form">
      <div>
        <span>Make</span>
        <input
          name="Make"
          onChange={formik.handleChange}
          value={formik.values.Make}
          disabled={params?.id}
        />
      </div>
      <div>
        <span>Model</span>
        <input
          name="Model"
          onChange={formik.handleChange}
          value={formik.values.Model}
          disabled={params?.id}
        />
      </div>
      <div className="year">
        <span>Year</span>
        <DatePicker
          className="date-picker"
          value={
            formik.values.Vehyear ? moment(formik.values.Vehyear) : undefined
          }
          onChange={(val) => {
            formik.setFieldValue("Vehyear", moment(val).format("YYYY"));
          }}
          picker="year"
          disabled={params?.id}
        />
      </div>
      <div>
        <span>Vehicle category</span>
        <Select
          options={[
            {
              label: "Light Truck",
              value: "LightTruck",
            },
            {
              label: "Truck",
              value: "Truck",
            },
            {
              label: "Passenger Car",
              value: "PassCar",
            },
            {
              label: "SUV",
              value: "SUV",
            },
            {
              label: "CUV",
              value: "CUV",
            },
          ]}
          name="Vehiclecat"
          onChange={(val) => {
            formik.setFieldValue("Vehiclecat", val);
          }}
          value={formik.values.Vehiclecat}
          disabled={params?.id}
        />
      </div>
      <div>
        <span>Split Fitment</span>
        <input
          name="Splitfitment"
          onChange={formik.handleChange}
          value={formik.values.Splitfitment}
          disabled={params?.id}
        />
      </div>
    </div>
  );
};

const TireForm = ({ formik, params }) => {
  const disabledDate = (current) => {
    // Can not select days before today and today
    return (
      current &&
      formik.values.Bstdk &&
      current < moment(formik.values.Bstdk, "YYYYMMDD").endOf("day")
    );
  };
  return (
    <div className="form tyre-info">
      <div>
        <span>Date of Purchase</span>
        <DatePicker
          className="date-picker"
          onChange={(date) => {
            formik.setFieldValue("Dateofremoval", "");
            if (date)
              formik.setFieldValue("Bstdk", moment(date).format("YYYYMMDD"));
            else formik.setFieldValue("Bstdk", "");
          }}
          name="Bstdk"
          disabled={params.id}
          value={
            formik.values.Bstdk && formik.values.Bstdk !== "00000000"
              ? moment(formik.values.Bstdk, "YYYYMMDD")
              : null
          }
        />
      </div>
      {formik.touched?.Bstdk && formik.errors?.Bstdk && (
        <div className="error-msg">{formik.errors?.Bstdk}</div>
      )}
      <div>
        <span>Date of Removal</span>
        <DatePicker
          className="date-picker"
          onChange={(date) => {
            if (date)
              formik.setFieldValue(
                "Dateofremoval",
                moment(date).format("YYYYMMDD")
              );
            else formik.setFieldValue("Dateofremoval", "");
          }}
          name="Dateofremoval"
          disabled={params.id}
          disabledDate={disabledDate}
          format={"YYYY-MM-DD"}
          value={
            formik.values.Dateofremoval &&
            formik.values.Dateofremoval !== "00000000"
              ? moment(formik.values.Dateofremoval, "YYYYMMDD")
              : ""
          }
        />
      </div>
      {!params.id && (
        <div>
          <b>Field mark with * are mandatory</b>
        </div>
      )}
    </div>
  );
};

const NewClaim = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmSubmitModal, setConfirmSubmitModal] = useState(false);
  const [vals, setVals] = useState({});
  const [selectedTD, setSelectedTD] = useState({});

  const formik = useFormik({
    initialValues: {
      Bstkd: "",
      Bstdk: "", // date
      Erdat: moment().format("YYYYMMDD"), // date
      Kunnr: "1100000",
      Vkorg: "1000",
      Spart: "10",
      Name1: "name",
      Street: "",
      Ort01: "",
      Vtweg: "10",
      Pstlz: "",
      Make: "",
      Model: "",
      Vehyear: "",
      Vehiclecat: "",
      Splitfitment: "",
      // Bstkd: "",
      Dateofremoval: "",
      Land1: "SG",
      Items: [
        {
          Posex: "10",
          Msize: "",
          Matnr: "",
          Pattern: "",
          Augru: "",
          Kwmeng: "",
          Meins: "pc",
          Werks: "",
          Dotcutattached: "NO",
          Picture: "NO",
          MileageTirekm: "",
          DrivingCondition: "",
          ZzclaimReason: "",
          ThreadDepth: "",
          TyreRotFreq: "",
          InpressureTyre: "",
          LoadPerc: "",
          Ean: "",
          Dotno: "",
        },
      ],
      Attachments: [],
    },
    validationSchema: claimValidation,
    onSubmit: (vals) => {
      let values = JSON.parse(JSON.stringify({ ...vals }));
      if (
        checkTD() ||
        values.Attachments.filter(
          (ele) => ele.Doctype === "TIREPIC" && ele.Docid
        ).length === 0
        // values.Attachments.filter(
        //   (ele) => ele.Doctype === "TIREPIC" && ele.Docid
        // ).length !== values.Items?.length
      )
        return;
      values.Attachments = values.Attachments.filter((ele) => {
        return !ele.message?.includes("not uploaded.");
      });
      values.Items = vals.Items?.map((itm) => {
        delete itm.claimReason;
        return { ...itm, Kwmeng: parseFloat(itm.Kwmeng).toFixed(2) };
      });
      setVals(values);
      setConfirmSubmitModal(true);
    },
  });
  const submit_claim = useSelector((state) => state?.claims?.create);
  const claim = useSelector(
    (state) => state?.claims?.details?.data?.claim_list
  );
  const timeOutRef = useRef();
  const prodsData = useSelector(
    (state) => state?.orders?.products?.data?.products
  );
  const prodsDataLoading = useSelector(
    (state) => state?.orders?.products?.loading
  );
  const docList = useSelector(
    (state) => state?.claims?.claim_doc_list?.data?.claim_doc_list
  );
  const pdf_content = useSelector(
    (state) => state?.claims?.claim_doc?.data?.pdf_content
  );
  const removeAttachments = (doc_id) => {
    let arr = formik.values.Attachments;
    let index = arr?.findIndex((ele) => ele.Docid === doc_id);
    arr.splice(index, 1);
    formik.setFieldValue(`Attachments`, arr);
  };

  const renderDocList = (vals, type) => {
    return vals?.length > 0 ? (
      <ul className="file-links">
        {vals
          ?.filter((itm) => itm.Doctype === type)
          ?.map((ele) => (
            <li
              onClick={() => {
                dispatch(
                  download_doc_claim_list({
                    email: localStorage.getItem("email"),
                    file_id: ele.Docid,
                  })
                );
              }}
            >
              {ele.Filename}
            </li>
          ))}
      </ul>
    ) : (
      "-"
    );
  };

  const claimReasons = [
    {
      label: `Tread Separation ( Broken belt, Belt edge looseness, bulge on tread, belt separation)`,
      value: `Tread Separation ( Broken belt, Belt edge looseness, bulge on tread, belt separation)`,
    },
    {
      label: `Sidewall Separation (Bulge inside tyre, bulge on sidewall)`,
      value: `Sidewall Separation (Bulge inside tyre, bulge on sidewall)`,
    },
    {
      label: `Out of Round (Vibration, cannot balance, poor ride handling, high balance)`,
      value: `Out of Round (Vibration, cannot balance, poor ride handling, high balance)`,
    },
    {
      label: `Irregular Wear (Rapid wear)`,
      value: `Irregular Wear (Rapid wear)`,
    },
    {
      label: `Bend Bead (Bead warp, kinked bead, broken bead)`,
      value: `Bend Bead (Bead warp, kinked bead, broken bead)`,
    },
    {
      label: `Indentation on sidewall`,
      value: `Indentation on sidewall`,
    },
    {
      label: `Black on WSW (Dirty WSW)`,
      value: `Black on WSW (Dirty WSW)`,
    },
    {
      label: `New tyre claim (Damaged sidewall, pin hole)`,
      value: `New tyre claim (Damaged sidewall, pin hole)`,
    },
    {
      label: `Others`,
      value: `Others`,
    },
  ];

  useEffect(() => {
    const el = document.querySelector(".error-msg");
    (el?.parentElement ?? el)?.scrollIntoView({ behavior: "smooth" });
  }, [formik.isSubmitting]);

  const vehicleInfo = useMemo(() => {
    let arr = docList?.reduce((prev, curr) => {
      if (prev[parseInt(curr.Posnr)]) {
        prev[parseInt(curr.Posnr)].push(curr);
      } else {
        prev[parseInt(curr.Posnr)] = [curr];
      }
      return prev;
    }, {});

    return [
      {
        header: "IP Code *",
        key: "Matnr",
        width: 15,
        render: (index) => {
          return (
            <AutoComplete
              className="w100"
              showSearch
              allowClear
              options={
                prodsData?.length > 0
                  ? _.uniqBy(prodsData, "sku")?.map((ele) => ({
                      label: ele.sku,
                      value: ele.sku,
                    }))
                  : []
              }
              value={
                formik.values?.Items?.[index]?.Matnr
                  ? [formik.values?.Items?.[index]?.Matnr]
                  : undefined
              }
              onChange={(value) => {
                const val = value?.split(",")?.[0];
                let obj = {
                  email: localStorage.getItem("email"),
                };
                if (timeOutRef?.current) {
                  clearTimeout(timeOutRef?.current);
                }
                let items = formik.values.Items;
                items[index].Matnr = val;
                items[index].Msize = "";
                items[index].Pattern = "";
                items[index].Werks = "";
                items[index].Ean = "";
                items[index].ThreadDepth = "";
                formik.setFieldValue("Items", items);
                timeOutRef.current = setTimeout(() => {
                  if (val) {
                    dispatch(
                      get_products({
                        ...obj,
                        page: 1,
                        limit: 10,
                        search: val,
                        list_prod: true,
                      })
                    );
                  } else {
                    dispatch({
                      type: Products.RESET,
                    });
                  }
                }, 400);
              }}
              // searchValue={formik.values?.Items?.[index]?.Matnr}
              placeholder="Search by sku"
              defaultActiveFirstOption={false}
              notFoundContent={
                prodsDataLoading ? <div>Searching...</div> : <div>No Data</div>
              }
              onBlur={() => {
                if (prodsData?.length === 1) {
                  let items = formik.values.Items;
                  let obj = prodsData[0];

                  setSelectedTD({
                    ...selectedTD,
                    [obj.sku]: parseFloat(obj?.thread_depth).toFixed(2),
                  });
                  items[index].Msize = obj?.size ?? "";
                  items[index].Pattern = obj?.pattern ?? "";
                  items[index].Werks = obj?.plant ? obj?.plant : "";
                  items[index].Matnr = prodsData[0]?.sku;
                  items[index].Ean = obj?.ean ?? "";
                  items[index].Vtweg = obj?.vtweg ?? "";
                  items[index].ThreadDepth = parseFloat(
                    obj?.thread_depth
                  ).toFixed(2);
                  formik.setFieldValue("Items", items);
                }
              }}
              onSelect={(value) => {
                let items = formik.values.Items;
                const val = value?.split(",")?.[0];
                let obj = prodsData?.find((itm) => itm.sku === val);
                setSelectedTD({
                  ...selectedTD,
                  [obj.sku]: parseFloat(obj?.thread_depth).toFixed(2),
                });
                items[index].Msize = obj?.size ?? "";
                items[index].Pattern = obj?.pattern ?? "";
                items[index].Werks = obj?.plant ? obj?.plant : "";
                items[index].Matnr = val;
                items[index].Ean = obj?.ean ?? "";
                items[index].Vtweg = obj?.vtweg ?? "";
                items[index].ThreadDepth = parseFloat(
                  obj?.thread_depth
                ).toFixed(2);
                formik.setFieldValue("Items", items);
              }}
              disabled={params.id}
            />
          );
        },
      },
      { header: "Size", key: "Msize", width: 15, disabled: true },
      { header: "Pattern", key: "Pattern", width: 15, disabled: true },
      {
        disabled: params.id,
        header: "Quantity *",
        key: "Kwmeng",
        width: 15,
        type: "number",
      },
      { header: "DOT No *.", key: "Dotno", width: 15, disabled: params.id },
      { header: "Serial No.", key: "Ean", width: 15, disabled: true },
      {
        header: "Remaining Thread Depth (mm) *",
        type: "number",
        key: "ThreadDepth",
        width: 15,
        disabled: params.id,
        // show: (val)=> parseFloat(val).toFixed(2)
      },
      {
        disabled: params.id,
        header: "Claim Reason/Description *",
        key: "claimReason",
        altKey: "ZzclaimReason",
        width: 22,
        type: "select",
        options: claimReasons,
      },
      {
        disabled: params.id,
        header: "Picture *",
        key: "Picture",
        width: 15,
        render: (i) => {
          return params.id ? (
            renderDocList(arr?.[(i + 1) * 10], "TIREPIC")
          ) : (
            <div>
              <div>
                <input
                  type={"file"}
                  className=""
                  accept=".png, .jpg, .jpeg, .pdf"
                  id={"picture" + i}
                  onChange={(e) => {
                    if (formik.values.Attachments?.length + 1 > 9) {
                      toast.error("Only 9 files allowed");
                      document.getElementById("picture" + i).value = "";
                      return;
                    }

                    if (e?.target?.files[0].size < 102400) {
                      toast.error("File size must be greater than 100KB.");
                      document.getElementById("picture" + i).value = "";
                      return;
                    }

                    if (e?.target?.files[0].size > 3145728) {
                      toast.error("File must not exceed 3MB.");
                      document.getElementById("picture" + i).value = "";
                      return;
                    }
                    let formdata = new FormData();
                    formdata.append("files", e.target.files[0]);
                    endpoint
                      .post(apis.upload_claim_image, formdata, {
                        params: {
                          email: localStorage.getItem("email"),
                        },
                      })
                      .then((res) => {
                        let attachments = formik.values.Attachments;
                        attachments = [
                          ...attachments,
                          {
                            Docid: res.data.DocId ? res.data.DocId : "",
                            message: res?.data?.message,
                            Doctype: "TIREPIC",
                            Posnr: (i + 1) * 10 + "",
                            Filename: e?.target?.files?.[0]?.name,
                            Size: e?.target?.files?.[0]?.size,
                          },
                        ];
                        formik.setFieldValue(`Attachments`, attachments);
                        let items = formik.values.Items;
                        items[i]["Picture"] = "YES";
                        formik.setFieldValue(`Items`, items);
                        document.getElementById("picture" + i).value = "";
                      })
                      .catch((err) => {
                        console.log(err);
                        toast.error("Failed to upload");
                      });
                  }}
                />
              </div>
              {formik.values.Attachments?.filter(
                (ele) =>
                  ele.Doctype === "TIREPIC" && ele.Posnr === (i + 1) * 10 + ""
              )?.length > 0 && (
                <div className="files">
                  {formik.values.Attachments.filter(
                    (ele) =>
                      ele.Doctype === "TIREPIC" &&
                      ele.Posnr === (i + 1) * 10 + ""
                  )?.map((ele) => (
                    <span>
                      <label
                        className={`ellipsis ${
                          ele.message?.includes("not uploaded") ? "c-red" : ""
                        }`}
                        title={ele?.message}
                      >
                        {ele.Filename}
                      </label>
                      <img
                        className="ml1 cursor"
                        src={Close}
                        alt="close"
                        width={12}
                        onClick={() => {
                          removeAttachments(ele.Docid);
                        }}
                      />
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        },
      },
      {
        disabled: params.id,
        header: "DOT Cut out attached",
        key: "Dotcutattached",
        width: 15,
        render: (i) => {
          return params.id ? (
            renderDocList(arr?.[(i + 1) * 10], "DOTCUTPIC")
          ) : (
            <div>
              <div>
                <input
                  type={"file"}
                  className="w100"
                  accept=".png, .jpg, .jpeg, .pdf"
                  id={"Dotcutattached" + i}
                  onChange={(e) => {
                    if (formik.values.Attachments?.length + 1 > 9) {
                      toast.error("Only 9 files allowed");
                      document.getElementById("Dotcutattached" + i).value = "";
                      return;
                    }
                    if (e?.target?.files[0].size < 102400) {
                      toast.error("File size must be greater than 100KB.");
                      document.getElementById("Dotcutattached" + i).value = "";
                      return;
                    }
                    if (e?.target?.files[0].size >= 3145728) {
                      toast.error("Files are exceeding 3MB.");
                      document.getElementById("Dotcutattached" + i).value = "";
                      return;
                    }
                    let formdata = new FormData();
                    formdata.append("files", e?.target?.files[0]);
                    endpoint
                      .post(apis.upload_claim_image, formdata, {
                        params: {
                          email: localStorage.getItem("email"),
                        },
                      })
                      .then((res) => {
                        let attachments = formik.values.Attachments;
                        attachments = [
                          ...attachments,
                          {
                            Docid: res.data.DocId
                              ? res.data.DocId
                              : attachments?.length,
                            message: res?.data?.message,
                            Doctype: "DOTCUTPIC",
                            Posnr: (i + 1) * 10 + "",
                            Filename: e?.target?.files?.[0]?.name,
                            Size: e?.target?.files?.[0]?.size,
                          },
                        ];
                        formik.setFieldValue(`Attachments`, attachments);
                        let items = formik.values.Items;
                        items[i]["Dotcutattached"] = "YES";
                        formik.setFieldValue(`Items`, items);
                        document.getElementById("Dotcutattached" + i).value =
                          "";
                      })
                      .catch((err) => {
                        console.log(err);
                        toast.error("Failed to upload");
                      });
                  }}
                />
              </div>
              {formik.values.Attachments.filter(
                (ele) =>
                  ele.Doctype === "DOTCUTPIC" && ele.Posnr === (i + 1) * 10 + ""
              )?.length > 0 && (
                <div className="files">
                  {formik.values.Attachments.filter(
                    (ele) =>
                      ele.Doctype === "DOTCUTPIC" &&
                      ele.Posnr === (i + 1) * 10 + ""
                  )?.map((ele) => (
                    <span>
                      <label
                        className={`ellipsis ${
                          ele.message?.includes("not uploaded") ? "" : "c-red"
                        }`}
                      >
                        {ele.Filename}
                      </label>
                      <img
                        className="ml1 cursor"
                        src={Close}
                        alt="close"
                        width={12}
                        onClick={() => {
                          removeAttachments(ele.Docid);
                        }}
                      />
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        },
      },
      {
        disabled: params.id,
        header: "Mileage used (km)",
        key: "MileageTirekm",
        width: 15,
        type: "number",
      },
      {
        disabled: params.id,
        header: "Driving Condition",
        key: "DrivingCondition",
        width: 15,
        type: "select",
        options: [
          { label: "Highway", value: "A" },
          { label: "Off Road", value: "B" },
          { label: "City (Urban)", value: "C" },
          { label: "Mixed", value: "D" },
        ],
      },
      {
        disabled: params.id,
        header:
          "Mostly the vehicle runs with how much percentage of rated Load.(%)",
        key: "LoadPerc",
        width: 22,
        type: "select",
        options: [
          { label: "80%", value: "80%" },
          { label: "100%", value: "100%" },
          { label: "125%", value: "125%" },
          { label: "150%", value: "150%" },
          { label: ">150%", value: ">150%" },
        ],
      },
      {
        disabled: params.id,
        header: "Frequency of checking inflation pressure of tyre.",
        key: "InpressureTyre",
        width: 22,
        type: "select",
        options: [
          { label: "Once a week", value: "WEEKLY" },
          { label: "Once a month", value: "MONTHLY" },
          { label: "Once two months", value: "TWOMONTHS" },
          { label: "> 2 Months", value: ">TWOMONTHS" },
        ],
      },
      {
        disabled: params.id,
        header: "Tyre Rotation Frequency (km)",
        key: "TyreRotFreq",
        width: 15,
        type: "select",
        options: [
          { label: "5,000 kms (3,107 miles)", value: "5000KM" },
          { label: "10,000 kms (6,214 miles)", value: "10000KM" },
          { label: "15,000 kms (9,321 miles)", value: "15000KM" },
          { label: "20,000 kms (12,427 miles)", value: "20000KM" },
        ],
      },
    ];
    // eslint-disable-next-line
  }, [
    prodsData,
    prodsDataLoading,
    formik.values.Items,
    formik.values.Attachments,
    docList,
  ]);

  useEffect(() => {
    if (submit_claim?.success) {
      if (submit_claim?.data?.error_details?.length > 0) {
        toast.error(
          submit_claim?.data?.error_details?.[0] +
            "; Please contact OMNI admin."
        );
        dispatch({
          type: SubmitClaims.RESET,
        });
      } else {
        toast.success(submit_claim?.data?.message);
        dispatch({
          type: SubmitClaims.RESET,
        });
        history.push("/claims");
      }

      // formik.resetForm()
    }
    // eslint-disable-next-line
  }, [submit_claim]);

  useEffect(() => {
    if (pdf_content) {
      let a = document.createElement("a");
      a.href = pdf_content;
      a.download = "ClaimPic-" + new Date().getTime();
      a.click();
      a.remove();
      dispatch({
        type: DownloadDocClaimList.RESET,
      });
    }
    // eslint-disable-next-line
  }, [pdf_content]);

  useEffect(() => {
    if (claim?.length > 0 && params.id) {
      let obj = {
        Bstkd: "",
        Bstdk: "", // date
        Erdat: "", // date
        Kunnr: "",
        Vkorg: "1000",
        Spart: "10",
        Pattern: "",
        Name1: "",
        Street: "",
        Ort01: "",
        Vtweg: "",
        Pstlz: "",
        Make: "",
        Model: "",
        Vehyear: "",
        Vehiclecat: "",
        Splitfitment: "",
        Clstatus: "",
        // Bstkd: "",
        Dateofremoval: "",
        Items: [],
        Attachments: [],
      };
      claim.forEach((ele) => {
        let item = {
          Posex: "10",
          Msize: "",
          Pattern: "",
          Matnr: "",
          Augru: "",
          Kwmeng: "",
          Meins: "",
          Werks: "",
          Dotcutattached: "NO",
          Picture: "NO",
          MileageTirekm: "",
          DrivingCondition: "",
          ZzclaimReason: "",
          ThreadDepth: "",
          TyreRotFreq: "",
          InpressureTyre: "",
          LoadPerc: "",
          Ean: "",
          Clstatus: "",
          Dotno: "",
        };

        Object.keys(ele).forEach((itm) => {
          if (
            Object.keys(item).includes(itm) ||
            itm === "Ean" ||
            itm === "Zmeng" ||
            itm === "ZzclaimReason" ||
            itm === "ClaimDesc"
          ) {
            if (itm === "ZzclaimReason" || itm === "ClaimDesc") {
              if (
                claimReasons.find(
                  (itm) =>
                    itm.value === ele["ZzclaimReason"] ||
                    itm.value === ele["ClaimDesc"]
                )?.value
              ) {
                item["ZzclaimReason"] =
                  ele["ZzclaimReason"] || ele["ClaimDesc"];
              } else {
                item["ZzclaimReason"] =
                  ele["ZzclaimReason"] || ele["ClaimDesc"];
                item["claimReason"] = "Others";
              }
            } else if (itm === "Zmeng") {
              if (parseInt(ele.Zmeng) !== 0) {
                item["Kwmeng"] = ele.Zmeng;
              } else {
                item["Kwmeng"] = ele.Kwmeng;
              }
            } else {
              item[itm] = ele[itm];
            }
          }
          if (Object.keys(obj).includes(itm) && !obj[itm]) {
            obj[itm] = ele[itm];
            if (itm === "Erdat") {
              obj[itm] = moment(ele[itm], "DD.MM.YYYY").format("YYYYMMDD");
            }
          }
        });
        obj.Items.push(item);
      });
      formik.setValues(obj);
    }
    // eslint-disable-next-line
  }, [claim]);

  // const popState = (e) => {
  //   window.confirm("Are you sure you want to go back from creating new claim ?")
  // }

  useEffect(() => {
    if (params?.id) {
      dispatch(
        get_claim({
          email: localStorage.getItem("email"),
          claim_id: params.id,
        })
      );

      dispatch(
        doc_claims_list({
          email: localStorage.getItem("email"),
          claim_id: params.id,
        })
      );
    }
    dispatch(
      get_addresses({
        email: localStorage.getItem("email"),
      })
    );

    // window.addEventListener('popstate', popState);

    // return () => {
    //   window.removeEventListener('popstate', popState)
    // }
    // eslint-disable-next-line
  }, []);

  const checkTD = () => {
    let check_td = false;
    let keys = Object.keys(selectedTD);
    for (let i of keys) {
      if (
        parseFloat(
          formik.values.Items?.find((ele) => ele.Matnr === i)?.ThreadDepth
        ) > parseFloat(selectedTD[i])
      ) {
        check_td = true;
      }
    }
    return check_td;
  };

  return (
    <NavWrap>
      <PopupComponent open={confirmModal}>
        <div className="cancel-popup">
          <h3>Are you sure you want to go back from creating new claim ?</h3>
          <div className="cancel-btns mt2">
            <button
              className="cancel-btn mr2"
              onClick={() => {
                setConfirmModal(false);
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                history.push("/claims");
              }}
              className="primary-btn"
            >
              Confirm
            </button>
          </div>
        </div>
      </PopupComponent>

      <PopupComponent open={confirmSubmitModal}>
        <div className="cancel-popup">
          <h3>Are you sure you want to submit a new claim ?</h3>
          <div className="cancel-btns mt2">
            <button
              className="cancel-btn mr2"
              onClick={() => {
                setConfirmSubmitModal(false);
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                dispatch(submit_claims(vals));
              }}
              className="primary-btn"
              disabled={submit_claim?.loading}
            >
              Confirm
            </button>
          </div>
        </div>
      </PopupComponent>

      {claim?.length === 0 && params.id ? (
        <div className="m2 claim-card">
          <span className="close">
            <img
              src={Close}
              alt="close"
              className="cursor"
              width={15}
              onClick={() => {
                if (params?.id) history.push("/claims");
                else setConfirmModal(true);
              }}
            />
          </span>
          <div className="flex-center m2">
            <div className="content">
              <h1 className="nm large">Claim Not Found</h1>
              <span>
                Sorry, we couldn't find the claim you were looking for.
              </span>
              <span>Please check the claim number.</span>
              <span
                className="link"
                onClick={() => {
                  history.push("/claims");
                }}
              >
                Go Back to Claims
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="m2 claim-card">
          <span className="close">
            <img
              src={Close}
              alt="close"
              className="cursor"
              width={15}
              onClick={() => {
                if (params?.id) history.push("/claims");
                else setConfirmModal(true);
              }}
            />
          </span>
          <form onSubmit={formik.handleSubmit}>
            <div className="flex-between ml2 mr2 head-sec">
              <h3>
                {params?.id ? "Claim" : "Create Claim"}{" "}
                {params.id && (
                  <span
                    className={`status ml1 ${claim?.[0]?.Clstatus?.toLowerCase()}`}
                  >
                    {claim?.[0]?.Clstatus}
                  </span>
                )}
              </h3>
              {!params?.id && (
                <button type="submit" disabled={submit_claim?.loading}>
                  {submit_claim?.loading ? "Submitting" : "Submit"} claim
                </button>
              )}
            </div>

            <div className="d-flex header retail-owner-info">
              <div className="d-flex w100 form">
                <section className="w33 br-right">
                  <div className="w100">
                    <span className="w50">Date of Claim *</span>
                    <DatePicker
                      className="date-picker"
                      format={"YYYY-MM-DD"}
                      value={
                        formik.values.Erdat
                          ? moment(formik.values.Erdat, "YYYYMMDD")
                          : ""
                      }
                      disabled={true}
                    />
                  </div>
                </section>
                <section className="w33 br-right">
                  <div className="w100">
                    <span className="w50">Customer Claim ID</span>
                    <Input
                      onChange={formik.handleChange}
                      name="Bstkd"
                      value={formik.values.Bstkd}
                      disabled={params?.id}
                    />
                  </div>
                </section>
                <section className="w33">
                  {params.id && (
                    <div className="w100">
                      <span className="w50">Omni's Claim ID</span>
                      <Input value={params.id} disabled={true} />
                    </div>
                  )}
                </section>
              </div>
            </div>

            <div className="d-flex retail-owner-info">
              <section className="w33 br-right">
                <h3>Information</h3>
                <RetailerOwnerForm formik={formik} params={params} />
              </section>
              <section className="w33 br-right">
                <h3>Vehicle Info</h3>
                <VehicleForm formik={formik} params={params} />
              </section>
              <section className="w33">
                <h3>Tyre Info</h3>
                <TireForm formik={formik} params={params} />
              </section>
            </div>
            <div className="w100">
              <AddTable
                columns={vehicleInfo}
                values={formik.values.Items}
                attachMents={formik.values.Attachments}
                errors={formik.errors.Items}
                selectedTD={selectedTD}
                touched={formik.touched.Items}
                picError={
                  formik.values.Attachments.filter(
                    (ele) => ele.Doctype === "TIREPIC" && ele.Docid
                  ).length === 0
                  // formik.values.Attachments.filter(
                  //   (ele) => ele.Doctype === "TIREPIC" && ele.Docid
                  // ).length !== formik.values.Items?.length
                }
                label={"Tyre Information"}
                removeItem={(i) => {
                  let items = formik.values.Items;
                  items.splice(i, 1);
                  formik.setFieldValue("Items", items);
                }}
                isEdit={params.id}
                addRow={() => {
                  formik.setFieldValue("Items", [
                    ...formik.values.Items,
                    {
                      Posex: (
                        (formik.values.Items?.length + 1) *
                        10
                      ).toString(),
                      Msize: "",
                      Matnr: "",
                      Augru: "",
                      Kwmeng: "",
                      Meins: "",
                      Werks: "",
                      Dotcutattached: "NO",
                      Picture: "NO",
                      MileageTirekm: "",
                      DrivingCondition: "",
                      Pattern: "",
                      ZzclaimReason: "",
                      ThreadDepth: "",
                      TyreRotFreq: "",
                      InpressureTyre: "",
                      Ean: "",
                      LoadPerc: "",
                    },
                  ]);
                }}
                onChange={(value, idx, key) => {
                  let items = formik.values.Items;
                  items[idx][key] = value;
                  formik.setFieldValue(`Items`, items);
                }}
              />
            </div>
            <div className="w100 m2">
              <div className="req-sec">
                <h3>Please send us the following: </h3>
                <div className="d-flex m1">
                  <ul>
                    <li>1. Completed Claim Form</li>
                    <li>2. Photo of DOT cut out. </li>
                    <li>3. Photo of the tread pattern </li>
                  </ul>
                  <ul className="ml4">
                    <li>
                      4. Photo showing the Brand, Pattern name & Tyre Size
                    </li>
                    <li>
                      5. Photo of the tyre showing the specific warrantable
                      defect.
                    </li>
                    <li>
                      6. The test result of rim and tyre required for vibration
                      and imbalance claim.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </form>

          <div className="w100 m1 claim-footer">
            <div className="w50">
              <h3>Warranty</h3>
              <div>
                <p>
                  To view the detailed terms and conditions of this warranty,
                  please visit the warranty section on www.omni-united.com
                </p>
              </div>
            </div>
            <div className="w50">
              <h3>Disclaimer</h3>
              <p>
                This warranty or any warranty stated or referred to herein, is
                exclusive and in lieu of any other warranty regarding the
                quality of the tyres, whether expressed or implied and remedies
                for breach thereof shall be limited to those specifically
                provided herein.
              </p>
            </div>
          </div>
        </div>
      )}
    </NavWrap>
  );
};

export default NewClaim;
